import { render, staticRenderFns } from "./timemarks.vue?vue&type=template&id=2b5d6124&scoped=true&"
import script from "./timemarks.vue?vue&type=script&lang=js&"
export * from "./timemarks.vue?vue&type=script&lang=js&"
import style0 from "./timemarks.vue?vue&type=style&index=0&id=2b5d6124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d6124",
  null
  
)

export default component.exports